import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogTitle,
  AlertDialogTrigger,
} from '@/shared/components/ui/alert-dialog';
import { Button, buttonVariants } from '@/shared/components/ui/button';
import { Icon } from '@/shared/components/ui/icon';
import { useAuthStore } from '@/stores/authStore';

/**
 * GNB [로그아웃] (Figma header 870:10660: Button Small · Filled/grey · logout 아이콘)
 * 누르면 로그아웃 확인 팝업(Pop-Up 870:11057)을 띄운다.
 * 팝업 버튼은 디자인 그대로 왼쪽 [로그아웃](회색) · 오른쪽 [취소](검정).
 */
export const LogoutButton = ({ iconOnly = false }: { iconOnly?: boolean }) => {
  const logout = useAuthStore((s) => s.logout);
  return (
    <AlertDialog>
      <AlertDialogTrigger asChild>
        <Button
          variant="grey"
          size="small"
          leftIcon={<Icon name="logout-line-16" />}
          aria-label={iconOnly ? '로그아웃' : undefined}
        >
          {iconOnly ? undefined : '로그아웃'}
        </Button>
      </AlertDialogTrigger>
      <AlertDialogContent>
        <AlertDialogTitle>루다링크에서 로그아웃돼요.</AlertDialogTitle>
        <AlertDialogDescription>로그아웃 하시겠어요?</AlertDialogDescription>
        <AlertDialogFooter>
          {/* 실수로 Enter를 눌러도 로그아웃되지 않게 기본 포커스는 [취소](Radix Cancel)에 둔다 */}
          <AlertDialogAction
            className={buttonVariants({ variant: 'grey', size: 'large' })}
            onClick={() => void logout()}
          >
            로그아웃
          </AlertDialogAction>
          <AlertDialogCancel
            className={buttonVariants({ variant: 'primary', size: 'large' })}
          >
            취소
          </AlertDialogCancel>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
